<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <Button class="add_item" icon="md-add" type="primary" ghost @click="addCustomerStatus = true">新增</Button>
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input class="search-ipt" type="text" v-model="searchIpt.keyword" placeholder="请输入用户名或手机号" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getCustomerList">搜索</Button>
            <Button class="top_search_btn" type="primary" ghost icon="ios-funnel" @click="topSearchStatus = true">高级搜索
            </Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="customerData">
        <template slot-scope="{ row }" slot="name">
          <div :class="[row.customerUserId ? 'jump_color' : '']" @click="toUserDetail(row.customerUserId)">{{row.name}}{{row.customerUserId ? '' : '(非用户)'}}</div>
        </template>
        <template slot-scope="{ row, index }" slot="question">
          <div class="jump_color ivu-table-cell-ellipsis" @click="checkDetail(row,row.id)">{{row.question}}</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getCustomerList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Select class="choose_role search_item" v-model="searchIpt.customer" placeholder="请选择客服">
          <Option v-for="(item,index) in customerList" :value="item.id" :key="index">{{item.name}}</Option>
        </Select>
        <div class="search_time search_item">
          <DatePicker class="time" :value="searchIpt.startTime" type="date" @on-change="getBeginDate"  format="yyyy-MM-dd" placeholder="请输入开始时间"></DatePicker>
          <DatePicker class="time" :value="searchIpt.endTime" type="date" @on-change="getEndDate" format="yyyy-MM-dd" placeholder="请输入结束时间"></DatePicker>
        </div>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.role" placeholder="请输入角色" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.seniorKeyword" placeholder="请输入用户名或手机号" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
    <Modal class="add_customer_modal" v-model="addCustomerStatus" title="新增用户" @on-ok="addCustomerBtn"
           @on-cancel="cancelAddCustomer">
      <div class="modal_wrapper">
        <Input class="search_item" type="text" v-model="addCustomer.username" placeholder="请输入用户名" clearable/>
        <Input class="search_item" type="text" v-model="addCustomer.tel" placeholder="请输入手机号" clearable/>
        <Input class="search_item" type="text" v-model="addCustomer.role" placeholder="请输入身份" clearable/>
        <Input class="search_item" type="textarea" v-model="addCustomer.remark" :autosize="{minRows: 4,maxRows:4}"
               placeholder="请输入备注"/>
      </div>
    </Modal>
    <Modal class="customer_detail" v-model="customerDetailStatus" width="840" title="客服记录">
      <div class="detail_wrapper">
        <div class="use_info">
          <div class="info_item">
            <span class="label_item">用户名：</span>
            <span class="data_item">{{rowDataDetail.name}}</span>
          </div>
          <div class="info_item">
            <span class="label_item">手机号：</span>
            <span class="data_item">{{rowDataDetail.phone}}</span>
          </div>
          <div class="info_item">
            <span class="label_item">身份：</span>
            <span class="data_item">{{rowDataDetail.kind}}</span>
          </div>
        </div>
        <div class="record_list_wrapper">
          <p class="wx_date">{{recordDetail.wxTime}}</p>
          <div class="record_list">
            <div class="record_item" v-for="(item,index) in recordDetail" :key="index">
              <p class="record_txt">{{index + 1}},{{item.question}}</p>
              <div class="record_ctrl_info">
                <span class="ctrl_person">{{item.waiterName}}</span>
                <!--<Time class="ctrl_time" type="datetime" :time="item.lastTime"></Time>-->
                <span class="ctrl_time">{{item.lastTime}}</span>
              </div>
            </div>
          </div>
          <Input class="record_txt" v-model="record_txt" type="textarea" placeholder="请录入客服记录内容"
                 :autosize="{minRows: 4,maxRows:4}"/>
        </div>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="cancelRecordDetail">关闭</Button>
        <Button class="add_record_btn" type="info" icon="md-add" @click="addCustomerRecord">添加</Button>
      </div>
      <p class="tips_info" v-if="tipsStatus">请先录入客服记录内容</p>
    </Modal>
  </div>
</template>
<script>
  import {_getCustomerList, _addCustomer, _getCustomerDetail, _addCustomerRecord,_getCustomerRoleList} from '../api/api';
  import {dealDate} from '../common/common';
  import paging from '../templates/Paging.vue';

  export default {
    name: "Customer",
    components: {
      paging
    },
    data() {
      return {
        pageSize: 10, // 每页条数
        currentNum: 0, // 当前页码
        totalNum: 0, // 数据总条数
        searchLevel: 'common',// common普通搜索，senior高级搜索
        filterCustomerList: [], // 客服过滤选择对象
        filterRoleList: [], // 用户角色过滤选择对象
        customerDetailStatus: false, // 客服记录详情状态
        addCustomerStatus: false, // 新增客服显示状态
        topSearchStatus: false, // 高级搜索显示状态
        recordDetail: [],//某项记录详情
        rowDataDetail: {},//点击客服详情的一条数据
        recordId: '',// 点击详情的Id
        record_txt: '', //输入记录内容
        tipsStatus: false, // 提示语显示状态
        searchIpt: {
          keyword: '',
          role: '',
          startTime: '',
          endTime: '',
          customer:'',
          seniorKeyword: '',
        },
        addCustomer: {// 添加新用户参数
          username: '',
          tel: '',
          role: '',
          remark: ''
        },
        roleList: [
          {
            value: 0,
            label: '全部'
          },
          {
            value: 1,
            label: '班主任'
          },
          {
            value: 2,
            label: '老师'
          },
          {
            value: 3,
            label: '家长'
          },
          {
            value: 4,
            label: '职工'
          },
          {
            value: 5,
            label: '学生'
          },
          {
            value: 6,
            label: '其他'
          },
        ],
        customerList: [],
        tableHeader: [],
        customerData: [
          {
            id: 1,
            username: '上善若水',
            tel: '15112341234',
            role: '老师',
            relationTime: '2018-10-10',
            customer: '将建成',
            wxTime: '2018-05-15 15:20',
            remark: [
              {
                record: '注册问题，需要帮忙导入名单。这个问题已经出现过三次，希望引起注意！',
                username: '杨江',
                time: '2018-15-23 15:25'
              },
              {
                record: '注册问题，需要帮忙导入名单',
                username: '杨江',
                time: '2018-15-23 15:25'
              },
              {
                record: '注册问题，需要帮忙导入名单。希望引起注意！',
                username: '杨江',
                time: '2018-15-23 15:25'
              }

            ]
          }
        ]
      }
    },
    methods: {
//      查询客服列表
      getCustomerList(msg) {
        const self = this;
        let params = {
          name: self.searchLevel === 'common' ? (/^\d*$/gi.test(self.searchIpt.keyword) ? '' : self.searchIpt.keyword) : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? '' : self.searchIpt.seniorKeyword),
          phone: self.searchLevel === 'common' ? (/^\d*$/gi.test(self.searchIpt.keyword) ? self.searchIpt.keyword : '') : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? self.searchIpt.seniorKeyword : ''),
          beginDate:self.searchIpt.startTime.toString().split('-').join(''),
          endDate:self.searchIpt.endTime.toString().split('-').join(''),
          kind:self.searchIpt.role,
          waiterName:self.searchIpt.customer,
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize,
          sort: 'createTime,desc'
        };
        _getCustomerList({params: params}).then(res => {
          if (res.code === 0) {
            self.customerData = res.data.content;
            self.totalNum = res.data.total;
            self.customerFilters();
          }
        })
      },
//      获取客服人员列表
      getCustomerRoleList() {
        const self = this;
        _getCustomerRoleList().then(res => {
          if(res.code === 0) {
            self.customerList = res.data;
          }
        })
      },
      //      获取高级搜索的开始时间
      getBeginDate(res) {
        this.searchIpt.startTime = res;
      },
//      获取高级搜索的结束时间
      getEndDate(res){
        this.searchIpt.endTime = res;
      },
//     新增客服用户
      addCustomerBtn() {
        const self = this;
        let dataInfo = {
          name: self.addCustomer.username,
          phone: self.addCustomer.tel,
          kind: self.addCustomer.role,
          question: self.addCustomer.remark
        };
        _addCustomer(dataInfo).then(res => {
          if (res.code === 0) {
            self.$Message.info('新增成功');
            self.getCustomerList();
            setTimeout(function () {
              self.addCustomerStatus = false;
            }, 1500)
          }
        })
      },
//      跳转到用户详情
      toUserDetail(id) {
        if (id) {
          this.$router.push(`/user/detail?id=${id}`);
        } else {
          this.$Message.info('无此用户')
        }

      },
//     高级搜索确认
      topSearchFn() {
        this.searchLevel = "senior";
        this.getCustomerList();
        this.searchIpt = {
          role: '',
          startTime: '',
          endTime: '',
          seniorKeyword: '',
        };
        this.topSearchStatus = false;
      },
//      高级搜索取消
      cancelSearchModel() {

      },
//      获取高级搜索日期
      getDateTime(date) {
        const self = this;
        self.searchIpt.dateTime = date;
        console.log("time", self.searchIpt.dateTime)
      },
//      新增用户取消
      cancelAddCustomer() {

      },
//      获取客服列表
      getCustomersList(msg) {

      },
//      查看客服记录详情
      checkDetail(row, id) {
        const self = this;
        if (row) {
          self.rowDataDetail = row;
          self.recordId = id;
        }
        let params = {
          sort:'createTime,desc'
        };
        self.customerDetailStatus = true;
        _getCustomerDetail(self.recordId,{params:params}).then(res => {
          if (res.code === 0) {
            self.recordDetail = res.data.content;
            self.recordDetail.length > 0 && self.recordDetail.forEach(item => {
              item.lastTime = dealDate(item.lastTime);
            })
          }
        })
      },
//      添加客服记录
      addCustomerRecord() {
        const self = this;
        let dataInfo = {
          customerId: self.recordId,
          question: self.record_txt
        };
        let params = {
          sort: 'createTime,desc'
        };
        if (self.record_txt) {
          self.tipsStatus = false;
          _addCustomerRecord(dataInfo, {params: params}).then(res => {
            if (res.code === 0) {
              self.record_txt = '';
              self.checkDetail();
            }
          });
        } else {
          self.tipsStatus = true;
        }
      },
//      取消客服记录详情
      cancelRecordDetail() {
        this.customerDetailStatus = false;
        this.getCustomerList();
      },

//      处理过滤客服对象参数
      customerFilters: function () {
        let filterList = [];
        let filterCustomerList = [];
        let self = this;
        for (const list of self.customerData) {
//          处理日期
          list.lastTime = dealDate(list.lastTime);
//          对过滤数据的处理
          let roleStatus = filterList.some(item => item.value == list.kind);
          let customerStatus = filterCustomerList.some(item => item.value == list.waiterName);
          !roleStatus && filterList.push({
            label: list.kind,
            value: list.kind
          });
          !customerStatus && filterCustomerList.push({
            label: list.waiterName,
            value: list.waiterName
          });
        }
        this.filterCustomerList = filterList;
        this.tableHeader = [
          {
            type: 'index',
            width: 50,
            align: 'center'
          },
          {
            title: '联系用户',
            slot: "name",
            key: 'name',
            className: 'username_col'
          },
          {
            title: '手机号',
            key: 'phone'
          },
          {
            title: '用户角色',
            key: 'kind',
            filters: filterList,
            filterMethod(value, row) {
              return row.kind.indexOf(value) > -1;
            }
          },
          {
            title: '最后联系时间',
            key: 'lastTime',
            width: 150,
            sortable: true
          },
          {
            title: '客服',
            key: 'waiterName',
            filters: filterCustomerList,
            filterMethod(value, row) {
              return row.waiterName.indexOf(value) > -1;
            }
          },
          {
            title: '跟进记录',
            key: 'question',
            slot: "question",
            ellipsis: true,
            tooltip: true,
          },
        ]
      }
    },
    computed: {},
    created() { 
    const {params}=this.$route
if(Object.getOwnPropertyNames(params).length){
  _getCustomerList({params:{phone:params.phone}})
    .then(res=>{
      const {content}=res.data
      if(content.length){
         this.checkDetail({
           name:content[0].name,
           phone:content[0].phone,
           kind:content[0].kind,
         },content[0].id)
      }else{
        _addCustomer({
          name: params.name,
          phone: params.phone,
          kind: (function(){
            if(params.teacherList){
              return 2
            }
            if(params.parentList){
              return 3
            }
            return 6
          }()),
          question: '创建成功'
        }).then(res => {
          if (res.code === 0) {
          return _getCustomerList({params:{phone:params.phone}})
          }
        }).then(res=>{
          if(res.code===0){
      const {content}=res.data
      if(content.length){
         this.checkDetail({
           name:content[0].name,
           phone:content[0].phone,
           kind:content[0].kind,
         },content[0].id)
         }
          }
        })
      }
    })
}
    },
    mounted() {
      this.getCustomerList();
      this.getCustomerRoleList();
    }
  };
</script>
<style scoped>
  /*.root_page{*/
  /*display: flex;*/
  /*flex-direction:column;*/
  /*}*/
  /*.ctrl-wrapper{*/
  /*flex: 0 0 36px;*/
  /*height:36px;*/
  /*display: flex;*/
  /*flex-direction:row;*/
  /*line-height:36px;*/

  /*}*/
  /*.ctrl-wrapper .add_item{*/
  /*display: inline-block;*/
  /*flex: 0 0 90px;*/
  /*width: 90px;*/
  /*height:36px;*/
  /*font-size: 16px;*/
  /*}*/
  /*.ctrl-wrapper .search_wrapper{*/
  /*flex: 1;*/
  /*text-align: right;*/
  /*}*/
  /*.common_search_wrapper .search-ipt{*/
  /*display:inline-table;*/
  /*width: 360px;*/
  /*}*/
  /*.table_wrapper{*/
  /*flex: 1;*/
  /*display: flex;*/
  /*flex-direction:column;*/
  /*}*/
  /*.main_table{*/
  /*flex:1;*/
  /*margin: 15px 0 25px;*/
  /*}*/
  /*.page_wrapper{*/
  /*flex: 0 0 34px;*/
  /*height:34px;*/
  /*text-align: center;*/
  /*}*/
  .username_col {
    font-size: 14px;
  }

  /*.record_color{*/
  /*font-size:12px;*/
  /*color:#2d8cf0;*/
  /*}*/
  .detail_wrapper {
    display: flex;
    flex-direction: column;
  }

  .detail_wrapper > .use_info {
    flex: 0 0 36px;
    height: 36px;
    display: flex;
    border-bottom: 1px solid #eee;
    line-height: 20px;
  }

  .info_item > .data_item {
    color: #333;
    font-size: 14px;
  }

  .use_info > .info_item {
    flex: 1;
  }

  .detail_wrapper > .record_list_wrapper {
    flex: 1;
  }

  .wx_date {
    line-height: 34px;
    font-size: 18px;
    color: #333;
  }

  .record_list {
    padding-bottom: 15px;
  }

  .record_item {
    display: flex;
    margin-top:6px;
    color: #666;
    font-size: 14px;
    line-height:18px;
  }

  .record_item .record_txt {
    flex: 1;
  }

  .record_item .record_ctrl_info {
    flex: 0 0 220px;
    width: 220px;
    text-align: right;
  }

  .tips_info {
    line-height: 20px;
    font-size: 14px;
    color: #f00;
  }
  .ctrl_person{
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue